@if (loading.isVisible$ | async) {
  <div class="app-loading">
    <div class="backdrop"></div>
    <div class="loader">
      <mat-progress-spinner mode="indeterminate" diameter="60" strokeWidth="6">
      </mat-progress-spinner>
      <div class="message" i18n>Loading...</div>
    </div>
  </div>
}
